// extracted by mini-css-extract-plugin
export default {"termsOfUse":"TermsOfUse_termsOfUse__6yn7y"};